import { apiClient } from './client';
import type {
  CreatureEncounterOpenView,
  EncounterOutcome,
  EncounterResolveResult,
} from '@/types/encounters';

const BASE = '/api/v1/CreatureEncounter';

/** Liste des encounters non resolus du caller (PU derive du JWT). */
export async function fetchMyOpenEncounters(): Promise<CreatureEncounterOpenView[]> {
  const { data } = await apiClient.get<CreatureEncounterOpenView[]>(`${BASE}/me/open`);
  return data;
}

/**
 * Resout un encounter avec l'outcome choisi. Le backend valide que
 * l'outcome est autorise pour le couple (hostility, danger) de la creature.
 */
export async function resolveEncounter(
  encounterId: number,
  outcome: EncounterOutcome,
  seed?: number,
): Promise<EncounterResolveResult> {
  const { data } = await apiClient.post<EncounterResolveResult>(
    `${BASE}/${encounterId}/resolve`,
    { outcome, seed },
  );
  return data;
}
